import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs/operators';

import { userHasSeenFeature } from '@main-client/src/app/account/account.helpers';
import { IAppState } from '@main-client/src/app/app.state';
import { experiencesViewFeaturesSeenIdentifier } from '@main-client/src/app/experiences-view/experiences-view.helper';

import isEmpty from 'lodash-es/isEmpty';

@Injectable({ providedIn: 'root' })
export class GroupsHomepageGuard implements CanActivate {
  constructor(public router: Router, public store: Store<IAppState>) {}

  canActivate(route: ActivatedRouteSnapshot) {
    return this.store.select('user').pipe(
      filter((user) => !isEmpty(user)),
      take(1),
      map(() => {
        return this.router.createUrlTree([
          '/hub',
          route.paramMap.get('groupSlug'),
          'experiences',
        ]);
      }),
    );
  }
}
